import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { BlockHeader } from 'components/blocks/BlockHeader';
import { BlockContent } from 'components/blocks/BlockContent';
import React, { useMemo } from 'react';
import { CollapsableList } from 'components/common/CollapsableList';
import { IHTMLParsedData, parseHTMLtoList } from 'util/parseHTMLtoList';
import { useSanitizedHtmlProps, SanitizeMode } from 'util/sanitized';

interface IProps {
  header: string,
  seoText: string
}

export const SkipassesLiftTicketsInfo = ({ header, seoText }: IProps) => {
  const { list, text } = useMemo<IHTMLParsedData>(() => parseHTMLtoList(seoText),
    [seoText]);
  const htmlProps = useSanitizedHtmlProps(text || '', SanitizeMode.NormalWithImages);

  return (
    <BoxWithShadow>
      <BlockHeader title={header} />
      <BlockContent>
        <div {...htmlProps} />
        <CollapsableList
          data={list}
          isFirstOpenByDefault
        />
      </BlockContent>
    </BoxWithShadow>
  );
};
